document.addEventListener("DOMContentLoaded", (event) => {
    /* Fixing the height of images in Featured grid slider (when more than 2 in a row) */
    const fixImageHeight = () => {
        const sliderImages = document.querySelectorAll('.recommendations .recommendations__products .product-item__image-wrapper');
        let smallestImgHeight = sliderImages[0].clientHeight;
        sliderImages.forEach((image,) => {
            if (image.clientHeight < smallestImgHeight) smallestImgHeight = image.clientHeight;
        })
        sliderImages.forEach((image) => {
            if (image.clientHeight > smallestImgHeight)
                image.style.height = smallestImgHeight + 'px';
        })
    }
    fixImageHeight();
    window.addEventListener('resize', fixImageHeight);
})



